import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Box,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useVoyageContextV2 } from "../../Contexts/VoyageContextV2";
import { useCompanyContext } from "../../Contexts/CompanyContext";
import PermitTest from "./permitComponents/PermitTest";
import PipeTrunkEntry from "./permitComponents/PipeTrunkEntry";

const permits = [
  { title: "Test Permit", id: "permit-test" },
  { title: "Pipe Trunk Entry", id: "pipe-trunk-entry" },
];

const Permits = () => {
  const { selectedTripId, selectedCargoIndex, currentVoyage } =
    useVoyageContextV2();
  const { companyLogo } = useCompanyContext();
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [activePermit, setActivePermit] = useState(null);
  const [isEditMode] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, [currentVoyage, selectedTripId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <Typography variant="h4">Loading data...</Typography>
      </Box>
    );
  }

  const openPermit = (permit) => {
    let PermitComponent;

    switch (permit.id) {
      case "permit-test":
        PermitComponent = PermitTest;
        break;
      case "pipe-trunk-entry":
        PermitComponent = PipeTrunkEntry;
        break;
      default:
        PermitComponent = PermitTest;
        break;
    }

    setActivePermit({ data: permit, Component: PermitComponent });
    setModalOpen(true);
  };

  const closePermit = () => {
    setModalOpen(false);
    setActivePermit(null);
  };

  return (
    <div className="permits-container">
      <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
        Permits
      </Typography>

      <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 4 }} elevation={3}>
        {permits.length === 0 ? (
          <Typography>No permits available for this trip.</Typography>
        ) : (
          permits.map((permit, index) => (
            <React.Fragment key={index}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 2,
                  px: 1,
                  "&:hover": { backgroundColor: "action.hover" },
                  borderRadius: 1,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  {permit.title}
                </Typography>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => openPermit(permit)}
                  startIcon={<Edit />}
                >
                  View / Edit
                </Button>
              </Box>
              {index < permits.length - 1 && <Divider />}
            </React.Fragment>
          ))
        )}
      </Paper>

      <Dialog open={modalOpen} onClose={closePermit} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {activePermit?.data.title}
        </DialogTitle>
        <DialogContent dividers>
          {activePermit && (
            <activePermit.Component
              permit={activePermit.data}
              voyage={currentVoyage}
              selectedTripId={selectedTripId}
              selectedCargoIndex={selectedCargoIndex}
              companyLogo={companyLogo}
              isEditMode={isEditMode}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Permits;
